// ** React Imports
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils
import { isUserLoggedIn } from '@utils'

// ** Store & Actions
import { handleLogout } from '@auth/redux/actions'
import { useDispatch, useSelector } from 'react-redux'

// ** Third Party Components
import { Power } from 'react-feather'
import Dropdown from 'react-multilevel-dropdown'
import { DropdownItem, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import adminMenu from '../../../components/navigation/admin-menu'
import setup from '../../../components/navigation/setup'
import { canViewMenuGroup, canViewMenuItem } from '../../utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faUser } from '@fortawesome/free-solid-svg-icons'

const DropItem = ({ element }) => {
  const history = useHistory()
  const hasChildren = !!element.children
  const hasNavLink = !!element.navLink

  const canView = hasChildren ? !!canViewMenuGroup(element) : !!canViewMenuItem(element)

  return canView && <Dropdown.Item onClick={(e) => hasNavLink ? history.push(`${element.navLink}`) : e.preventDefault()}>
    {element.icon}
    <span className='align-middle'>{element.title}</span>
    {hasChildren && (
      <Dropdown.Submenu>
        {element?.children?.map(child => {
          return <DropItem key={child.key} element={child} />
        })}
      </Dropdown.Submenu>
    )}
  </Dropdown.Item>
}

const UserDropdown = () => {
  // ** Store Vars
  const history = useHistory()
  const dispatch = useDispatch()
  const { isInForm } = useSelector(state => state.layout)

  // ** State
  const [userData, setUserData] = useState(null)
  const [adminMenuConfiguration, setAdminMenuConfiguration] = useState([])
  const [setupMenuConfiguration, setSetupMenuConfiguration] = useState([])

  const handleLogoutClick = () => {
    dispatch(handleLogout())
    history.push('/login')
  }
  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  useEffect(() => {
    setAdminMenuConfiguration(adminMenu)
    setSetupMenuConfiguration(setup)
  }, [isInForm])

  return (
    <>
      <Dropdown buttonClassName='dropdown-user nav-item bg-transparent' title={(
        <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
          <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
            <div className='user-nav d-sm-flex d-none'>
              <span className='user-name font-weight-bold'>{(userData && userData['firstName']) || ''}</span>
              <small className='user-status'>{userData?.role.name}</small>
            </div>
            <Avatar imgHeight='40' imgWidth='40' status='online' initials={true} content={(userData && userData['firstName']) || ''} />
          </DropdownToggle>
        </UncontrolledDropdown>
      )}>
        {adminMenu.map(element => <DropItem key={element.key} element={isInForm ? { ...element, navLink: '#', children: [] } : { ...element }} />)}

        <Dropdown.Item onClick={() => handleLogoutClick()}>
          <Power size={12} className='mr-75' />
          <span className='align-middle'>Cerrar Sesión</span>
        </Dropdown.Item>
      </Dropdown>
    </>
  )
}

export default UserDropdown
